import { isEqual, isFunction } from "lodash";
import React, { createContext, useCallback, useContext } from "react";

const TransactionsReportUIContext = createContext();

export function useTransactionsReportUIContext() {
  return useContext(TransactionsReportUIContext);
}

export const TransactionsReportUIConsumer =
  TransactionsReportUIContext.Consumer;

export function TransactionsReportUIProvider({
  transactionsReportUIEvents,
  children,
  queryParams,
  setQueryParamsBase,
  queryParamsChart,
  setQueryParamsChartBase
}) {
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const setQueryParamsChart = useCallback((nextQueryParams) => {
    setQueryParamsChartBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    queryParamsChart,
    setQueryParamsChartBase,
    setQueryParamsChart,
    openReceiptDialog: transactionsReportUIEvents.openReceiptDialog,
    handleExportButton: transactionsReportUIEvents.handleExportButton
  };

  return (
    <TransactionsReportUIContext.Provider value={value}>
      {children}
    </TransactionsReportUIContext.Provider>
  );
}
